export default "__VITE_ASSET__B_4pVrsK__"